<template>
  <main id="main">
    <div v-if="loading" class="d-flex justify-content-center align-items-center" style="height: 100vh;">
      <p>{{ t('loading') }}</p>
    </div>
    <template v-else>
      <header class="bg_gradient_theme_to_right p-4 rounded_header position-sticky top-0 shadow fadeIn">
        <div class="d-flex align-items-center mb-5">
          <img id="arrow_back_page" src="@/assets/imgs/back.svg" alt="" @click="$router.go(-1)">
          <p id="title_header_page" class="">{{ t('user_area') }}</p>
        </div>

        <div class="d-flex align-items-center justify-content-between gap-2" @click="$router.push({ name: 'TeacherMyProfile' })">
          <img :src="userInfo.profile_pic || require('@/assets/imgs/NoPath - Copy.svg')" class="rounded-pill shadow profile" alt="profile picture" @error="$event.target.src = require('@/assets/imgs/NoPath - Copy.svg')">

          <div class="d-flex flex-column justify-content-around gap-3 w-50">
            <p class="font_normal bold text-white text-truncate">{{ userInfo.name }} {{ userInfo.family }}</p>
            <p class="font_normal me-2 text-white text-truncate">{{ userInfo.email }}</p>
          </div>

          <div class="w-30 d-flex flex-column align-items-center justify-content-around gap-3">
            <button class="w-100 py-3 bg_orange rounded-pill gap-2 d-flex align-items-center justify-content-evenly shadow_button" @click.stop="showLogoutModal = true">
              <img src="@/assets/imgs/logout.svg" class="icon-size-1" alt="">
              <span class="text-white font_small">{{ t('logout') }}</span>
            </button>
          </div>
        </div>
      </header>

      <div class="p-3 pb-6">
        <div class="d-flex align-items-center justify-content-between bg_white rounded-4 shadow_box p-4 mb-3 cursor-pointer" @click="showLangModal = true">
          <div class="d-flex align-items-center gap-3">
            <img src="@/assets/imgs/translate_1.svg" class="icon-size-3" alt="">
            <p class="font_normal bold bold">{{ t('change_lang') }}</p>
          </div>
          <div class="d-flex align-items-center gap-2">
            <img v-if="currentLanguageData.pic" :src="currentLanguageData.pic" style="width: 24px; border-radius: 50%;" alt="flag">
            <span class="font_small text_color_gray">{{ currentLanguageData.title }}</span>
          </div>
        </div>

        <div class="d-flex align-items-center gap-3 bg_white rounded-4 shadow_box p-4 mb-3 cursor-pointer" @click="$router.push({ name: 'TeacherEditProfileInfo' })">
          <img src="@/assets/imgs/person.svg" class="icon-size-3" alt="">
          <p class="font_normal bold">{{ t('edit_profile') }}</p>
        </div>

        <div v-if="userInfo.lessons_teacher === 1" class="d-flex align-items-center gap-3 bg_white rounded-4 shadow_box p-4 mb-3 cursor-pointer" @click="$router.push({ name: 'TeacherStatus' })">
          <img src="@/assets/imgs/graph%20(1).svg" class="icon-size-3" alt="">
          <p class="font_normal bold">{{ t('teaching_grades') }}</p>
        </div>

        <div v-if="userInfo.lessons_teacher === 0" class="d-flex align-items-center gap-3 bg_white rounded-4 shadow_box p-4 mb-3 cursor-pointer" @click="$router.push({ name: 'TeacherRequestSubject' })">
          <img src="@/assets/imgs/graph%20(1).svg" class="icon-size-3" alt="">
          <p class="font_normal bold">{{ t('join_teachers') }}</p>
        </div>

        <div class="d-flex align-items-center gap-3 bg_white rounded-4 shadow_box p-4 mb-3 cursor-pointer" @click="$router.push({ name: 'TeacherContact' })">
          <img src="@/assets/imgs/support.svg" class="icon-size-3" alt="">
          <p class="font_normal bold">{{ t('contact_us') }}</p>
        </div>

        <div class="d-flex align-items-center gap-3 bg_white rounded-4 shadow_box p-4 mb-3 cursor-pointer" @click="goToInfoPage('about_us')">
          <img src="@/assets/imgs/information.svg" class="icon-size-3" alt="">
          <p class="font_normal bold">{{ t('about_us') }}</p>
        </div>

        <div class="d-flex align-items-center gap-3 bg_white rounded-4 shadow_box p-4 mb-3 cursor-pointer" @click="$router.push({ name: 'TeacherRules' })">
          <img src="@/assets/imgs/auction.svg" class="icon-size-3" alt="">
          <p class="font_normal bold">{{ t('terms_conditions') }}</p>
        </div>
      </div>
      <TeacherBottomNav />
    </template>

    <div v-if="showLangModal" class="modal_overlay" @click.self="showLangModal = false">
      <div class="modal_content bg_white rounded-4 p-4 shadow_box">
        <p class="text-center font_large bold mb-4">{{ t('select_lang') }}</p>
        <div class="d-flex flex-column gap-3 w-100">
          <button class="lang_button" @click="changeLanguage('fa')" :disabled="changingLanguage">
            {{ t('persian_dari') }}
          </button>
          <button class="lang_button" @click="changeLanguage('ps')" :disabled="changingLanguage">
            {{ t('pashto') }}
          </button>
        </div>
      </div>
    </div>

    <div v-if="showLogoutModal" class="modal_overlay" @click.self="showLogoutModal = false">
      <div class="modal_content bg_white rounded-4 p-4 shadow_box text-center" style="max-width: 320px;">
        <p class="bold font_medium mb-4">آیا مطمئن هستید میخواهید از اکانت خود خارج شوید؟</p>
        <div class="d-flex gap-3">
          <button class="button w-100 bg_red" @click="confirmLogout">{{ t('yes') }}</button>
          <button class="button w-100 bg_gray" @click="showLogoutModal = false">{{ t('no') }}</button>
        </div>
      </div>
    </div>

  </main>
</template>

<script>
import TeacherBottomNav from '@/components/TeacherBottomNav.vue'
import apiClient, { createFormData } from '@/services/api'
import { Decryption } from '@/utils/crypto'

export default {
  name: 'TeacherUserArea',
  components: {
    TeacherBottomNav
  },
  data() {
    return {
      userInfo: {},
      countries: [],
      loading: true,
      showLangModal: false,
      changingLanguage: false,
      showLogoutModal: false
    }
  },
  computed: {
    currentLanguageCode() {
      return localStorage.getItem('app_lang') || 'fa';
    },
    currentLanguageData() {
      const afghanistan = this.countries.find(c => c.title.includes('افغانستان'));
      const iran = this.countries.find(c => c.title.includes('ایران'));
      
      if (this.currentLanguageCode === 'ps') {
          return { title: this.t('pashto'), pic: afghanistan ? afghanistan.pic : null };
      }
      return { title: this.t('persian_dari'), pic: afghanistan ? afghanistan.pic : (iran ? iran.pic : null) };
    }
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
        this.loading = true;
        await this.fetchUserInfo();
        await this.fetchCountries();
        this.loading = false;
    },
    async fetchUserInfo() {
      try {
        const userId = localStorage.getItem('user_id');
        if (!userId) {
          this.$router.push({ name: 'TeacherLogin' });
          return;
        }

        const formData = createFormData({
          action: 'teacher_info',
          user_id: userId
        });
        const response = await apiClient.post('/public_info', formData);
        
        if (response.data) {
          this.userInfo = response.data;
        }

      } catch (error) {
        console.error("Error fetching user profile:", error);
      }
    },
    async fetchCountries() {
        try {
            const formData = createFormData({ action: 'country' });
            const response = await apiClient.post('/public_info', formData);
            if (Array.isArray(response.data)) {
                this.countries = response.data;
            } else if (response.data.data) {
                const raw = response.data.data;
                this.countries = typeof raw === 'string' ? Decryption(raw) : raw;
            }
        } catch (e) {
            console.error("Error fetching countries", e);
        }
    },
    confirmLogout() {
      localStorage.clear();
      this.$router.replace({ name: 'Language' });
    },
    async changeLanguage(newLang) {
      this.changingLanguage = true;
      try {
        const userId = localStorage.getItem('user_id');
        const formData = createFormData({
          teacher_id: userId,
          new_lang: newLang
        });
        const response = await apiClient.post('/teacher/change_language', formData);
        if (response.data.status === 'ok') {
          localStorage.setItem('app_lang', newLang);
          this.showLangModal = false;
          this.notify(response.data.message, 'success');
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        } else {
          this.notify(this.t('connection_error'), 'error');
        }
      } catch (error) {
        console.error("Error changing language:", error);
        this.notify(this.t('connection_error'), 'error');
      } finally {
        this.changingLanguage = false;
      }
    },
    goToInfoPage(pageType) {
        this.$router.push({ name: 'Info', params: { pageType: pageType } });
    }
  }
}
</script>

<style scoped>
.profile {
    width: 7rem;
    height: 7rem;
    border-radius: 50%;
    object-fit: cover;
    border: 3px solid #f1f1f1;
}
.cursor-pointer {
  cursor: pointer;
}
.text-truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.modal_overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(5px);
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal_content {
  background-color: white;
  width: 85%;
  max-width: 25rem;
  border-radius: 1.5rem;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 10px 30px rgba(0,0,0,0.2);
}
.lang_button {
  width: 100%;
  padding: 1rem;
  border-radius: 1rem;
  border: 1px solid #ddd;
  background-color: #f8f8f8;
  font-size: 1.1rem;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}
.lang_button:hover {
  background-color: #eee;
  transform: translateY(-2px);
}
.lang_button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}
.bg_red {
    background: #FF0000 !important;
    box-shadow: 0 5px 15px rgba(255, 0, 0, 0.2) !important;
    color: white;
}
.bg_gray {
    background: #9e9e9e !important;
    box-shadow: none !important;
    color: white;
}
</style>